module.exports = {"data":{"site":{"siteMetadata":{"landingPages":{"stickNSlideMetadata":{"title":"Stick-n-Slide"}}}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-stick-n-slide.json
// module id = 180
// module chunks = 13492888273300 60335399758886